import { render } from "./file-select.vue?vue&type=template&id=d36daed2"
import script from "./file-select.vue?vue&type=script&lang=js"
export * from "./file-select.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__